var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorProblem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "511px",
    height: "320px",
    viewBox: "0 0 511 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "errorProblem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u27A1\\uFE0F-Login-Flows-(WIP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-pages---Unexpected-site-down",
    transform: "translate(-131.000000, -214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "errorProblem",
    transform: "translate(131.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.303059,26.3871291 C347.058496,24.1214807 342.746647,22.0140856 338.37791,20.0600556 C237.621694,-24.9999504 104.796673,13.5942814 79.071773,59.6960701 C43.5976527,123.27048 134.26271,195.469385 108.31821,241.966501 C94.6553553,266.451756 87.0244404,266.451145 67.0935304,286.701446 C66.9204203,286.877419 66.7283475,287.086387 66.5191473,287.326516 C55.4798589,299.98494 55.7080218,319.982892 72.346169,319.982892 L369.427017,320 C420.307939,296.643292 464.775223,251.843579 462.793326,173.285217 C461.37419,117.037503 417.617698,61.7839127 351.303059,26.3871291 Z",
    id: "Fill-1",
    fill: "#FFF0D9",
    transform: "translate(260.892857, 160.000000) scale(-1, 1) translate(-260.892857, -160.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(201.428571, 43.879599)",
    fill: "#FF685A"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "106.999071 41.810301 98.3322857 34.5145151 87.4615714 63.6259532 102.211929 48.0133779 111.141214 55.5307023 122.367643 23.6034783"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "11.2262143 55.5302742 20.1555 48.0129498 34.9047857 63.6255251 24.0362143 34.5151572 15.3683571 41.8098729 -0.000214285714 23.6041204"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "68.8104643 0.000214046823 64.3008214 28.6225552 50.6776071 26.4842274 57.7254643 63.6256321 63.2315357 38.0919866 77.2661786 40.2966689"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cup",
    transform: "translate(427.500000, 159.464883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0208333,85.9725715 L63.0208333,139.040445 C63.0208333,150.319076 53.6113009,159.464883 42.006629,159.464883 L21.0148644,159.464883 C9.40953241,159.464883 0,150.319076 0,139.040445 L0,85.9725715 C0,84.4138458 1.29358796,83.1495461 2.89737303,83.1495461 L41.0232381,83.1495461 L38.9686772,94.9099067 L43.1748181,99.6297024 L43.4922751,110.319481 L45.1851594,99.2268712 L42.1175079,92.9053727 L45.975832,83.1495461 L60.1234603,83.1495461 C61.7199854,83.1495461 63.0208333,84.4138458 63.0208333,85.9725715",
    id: "Fill-3",
    fill: "#FFCA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8201788,123.106326 C75.8201788,125.176851 74.0612498,126.863004 71.9006965,126.863004 L61.6798212,126.863004 L61.6798212,97.5262319 L71.9006965,97.5262319 C74.0612498,97.5262319 75.8201788,99.2130201 75.8201788,101.283545 L75.8201788,123.106326 Z M71.9006965,91.1227903 L58.340242,91.1227903 C56.4997952,91.1227903 55,92.5529071 55,94.3248288 L55,130.065042 C55,131.82934 56.4997952,133.267081 58.340242,133.267081 L71.9006965,133.267081 C77.7421434,133.267081 82.5,128.706082 82.5,123.106326 L82.5,101.283545 C82.5,95.6768006 77.7421434,91.1227903 71.9006965,91.1227903 L71.9006965,91.1227903 Z",
    id: "Fill-5",
    fill: "#FFCA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7196821,55.9658732 L27.2574895,55.9658732 C27.1561028,55.9652223 27.0547161,55.9613165 26.9520212,55.9574108 C30.2735806,55.7751435 32.9102891,53.0404834 32.9102891,49.6919731 L32.9102891,49.5533198 C32.9102891,46.2048095 30.2735806,43.4701493 26.9520212,43.2930897 C27.0677983,43.2878821 27.1835754,43.2833254 27.2993524,43.2833254 L54.5442504,43.2833254 C51.0637428,43.2833254 48.2386512,46.0895905 48.2386512,49.5533198 L48.2386512,49.6919731 C48.2386512,53.1478909 51.0513148,55.9535051 54.5213566,55.9658732 L55.7386512,55.9658732 C59.7607601,55.9658732 63.0208333,59.2102308 63.0208333,63.2129504 L63.0208333,63.3730852 C63.0208333,67.3758049 59.7607601,70.6201624 55.7386512,70.6201624 L10.7196821,70.6201624 C6.69822737,70.6201624 3.4375,67.3758049 3.4375,63.3730852 L3.4375,63.2129504 C3.4375,59.2102308 6.69822737,55.9658732 10.7196821,55.9658732",
    id: "Fill-7",
    fill: "#F1DCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4583333,34.8972133 L11.4583333,34.7370785 C11.4583333,30.7343588 14.6759956,27.4900013 18.6457799,27.4900013 L41.5529009,27.4900013 C44.9816738,27.4821898 47.7571012,24.6746228 47.7571012,21.2161011 L47.7571012,21.0774478 C47.7571012,17.6137186 44.9739266,14.8074534 41.5386978,14.8074534 L60.9595876,14.8074534 C57.5198396,14.8074534 54.736665,17.6137186 54.736665,21.0774478 L54.736665,21.2161011 C54.736665,24.6746228 57.5120924,27.4821898 60.9447389,27.4900013 L68.4375535,27.4900013 C72.4066922,27.4900013 75.625,30.7343588 75.625,34.7370785 L75.625,34.8972133 C75.625,38.8999329 72.4066922,42.1442905 68.4375535,42.1442905 L18.6457799,42.1442905 C14.6759956,42.1442905 11.4583333,38.8999329 11.4583333,34.8972133",
    id: "Fill-9",
    fill: "#F1DCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.788783,13.6684185 C37.6943559,13.6684185 34.375,10.6418532 34.375,6.90919038 L34.375,6.7598353 C34.375,3.02656538 37.6943559,0 41.788783,0 L75.086217,0 C79.1799783,0 82.5,3.02656538 82.5,6.7598353 L82.5,6.90919038 C82.5,10.6418532 79.1799783,13.6684185 75.086217,13.6684185 L41.788783,13.6684185 Z",
    id: "Fill-11",
    fill: "#F1DCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6041667,70.6298079 C12.7205271,70.6246636 12.8382097,70.6201624 12.9545701,70.6201624 L50.4166667,70.6201624 C46.8987482,70.6201624 44.0439517,73.3922524 44.0439517,76.8137998 L44.0439517,76.9514076 C44.0439517,80.3723119 46.8987482,83.1495461 50.4166667,83.1495461 L12.9545701,83.1495461 C12.8382097,83.1495461 12.7205271,83.1450449 12.6041667,83.1399007 C15.9653953,82.9598531 18.625817,80.2591391 18.625817,76.9514076 L18.625817,76.8137998 C18.625817,73.5067112 15.9653953,70.8047112 12.6041667,70.6298079",
    id: "Fill-13",
    fill: "#F1DCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4794982,12.5293837 C16.3157438,12.5293837 13.75,9.97937443 13.75,6.83420927 C13.75,3.68838502 16.3157438,1.13903488 19.4794982,1.13903488 C22.6432525,1.13903488 25.2083333,3.68838502 25.2083333,6.83420927 C25.2083333,9.97937443 22.6432525,12.5293837 19.4794982,12.5293837",
    id: "Fill-15",
    fill: "#F1DCBC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "comp",
    transform: "translate(0.000000, 122.006689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.830357,178.469097 L113.571429,178.469097 L113.571429,13.3763782 C113.571429,5.98869278 119.560197,0 126.947975,0 L398.454455,0 C405.841589,0 411.830357,5.98869278 411.830357,13.3763782 L411.830357,178.469097 Z",
    id: "Fill-17",
    fill: "#A4ADD1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#FFFFFF",
    points: "121.808036 166.031404 404.129464 166.031404 404.129464 12.5707159 121.808036 12.5707159"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#D5D8E1",
    points: "121.808036 23.9381743 404.129464 23.9381743 404.129464 12.5707159 121.808036 12.5707159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.716259,195.586796 L92.0828481,195.586796 C82.7223014,195.586796 75.1339286,188.028833 75.1339286,178.705798 L75.1339286,178.535608 L449.665179,178.535608 L449.665179,178.705798 C449.665179,188.028833 442.076806,195.586796 432.716259,195.586796",
    id: "Fill-24",
    fill: "#E2E5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.245536,6.31861384 C265.245536,7.8880967 263.97131,9.16047843 262.399554,9.16047843 C260.827797,9.16047843 259.553571,7.8880967 259.553571,6.31861384 C259.553571,4.74913097 260.827797,3.47674924 262.399554,3.47674924 C263.97131,3.47674924 265.245536,4.74913097 265.245536,6.31861384",
    id: "Fill-25",
    fill: "#8B94A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.053571,19.9595639 C132.053571,20.901062 131.288844,21.6646827 130.345982,21.6646827 C129.402618,21.6646827 128.638393,20.901062 128.638393,19.9595639 C128.638393,19.0175647 129.402618,18.2544451 130.345982,18.2544451 C131.288844,18.2544451 132.053571,19.0175647 132.053571,19.9595639",
    id: "Fill-26",
    fill: "#F47779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.745536,19.9595639 C137.745536,20.901062 136.98131,21.6646827 136.037946,21.6646827 C135.094582,21.6646827 134.330357,20.901062 134.330357,19.9595639 C134.330357,19.0175647 135.094582,18.2544451 136.037946,18.2544451 C136.98131,18.2544451 137.745536,19.0175647 137.745536,19.9595639",
    id: "Fill-27",
    fill: "#FCBA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.852679,19.9595639 C146.852679,20.901062 146.088453,21.6646827 145.145089,21.6646827 C144.202227,21.6646827 143.4375,20.901062 143.4375,19.9595639 C143.4375,19.0175647 144.202227,18.2544451 145.145089,18.2544451 C146.088453,18.2544451 146.852679,19.0175647 146.852679,19.9595639",
    id: "Fill-28",
    fill: "#8DC756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.664746,18.2544451 L156.576325,18.2544451 C155.678957,18.2544451 154.872232,18.9323536 154.542679,19.9632227 L152.544643,26.211666 L186.696429,26.211666 L184.698392,19.9632227 C184.368192,18.9323536 183.562115,18.2544451 182.664746,18.2544451",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.954925,18.2544451 L191.866504,18.2544451 C190.968488,18.2544451 190.162411,18.9323536 189.832858,19.9632227 L187.834821,26.211666 L221.986607,26.211666 L219.988571,19.9632227 C219.658371,18.9323536 218.852293,18.2544451 217.954925,18.2544451",
    id: "Fill-30",
    fill: "#BDC2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.968318,18.2544451 L224.879896,18.2544451 C223.981881,18.2544451 223.175803,18.9323536 222.84625,19.9632227 L220.848214,26.211666 L255,26.211666 L253.001316,19.9632227 C252.671763,18.9323536 251.865686,18.2544451 250.968318,18.2544451",
    id: "Fill-31",
    fill: "#BDC2DB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#EBEDF7",
    points: "449.978805 178.535608 75.9593417 178.535608 75.9593417 178.08483 75.1339286 178.08483 75.1339286 177.398862 450.803571 177.398862 450.803571 178.08483 449.978805 178.08483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.594644,185.356083 L241.342856,185.356083 C237.568867,185.356083 234.508929,181.829317 234.508929,177.478643 L234.508929,177.398862 L291.428571,177.398862 L291.428571,177.478643 C291.428571,181.829317 288.36928,185.356083 284.594644,185.356083",
    id: "Fill-33",
    fill: "#A4ADD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.527517,197.993311 L2.47248301,197.993311 C1.10706266,197.993311 0,197.229938 0,196.28797 C0,195.346447 1.10706266,194.583074 2.47248301,194.583074 L507.527517,194.583074 C508.893583,194.583074 510,195.346447 510,196.28797 C510,197.229938 508.893583,197.993311 507.527517,197.993311",
    id: "Fill-34",
    fill: "#D8DCEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,89.8694329 C182.652491,89.8694329 182.142857,89.360544 182.142857,88.7326871 C182.142857,88.1048303 182.652491,87.5959413 183.281513,87.5959413 C183.910009,87.5959413 184.419643,88.1048303 184.419643,88.7326871 C184.419643,89.360544 183.910009,89.8694329 183.281513,89.8694329",
    id: "Fill-35",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,96.689908 C182.652491,96.689908 182.142857,96.181019 182.142857,95.5531621 C182.142857,94.9253053 182.652491,94.4164163 183.281513,94.4164163 C183.910009,94.4164163 184.419643,94.9253053 184.419643,95.5531621 C184.419643,96.181019 183.910009,96.689908 183.281513,96.689908",
    id: "Fill-36",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,103.510383 C182.652491,103.510383 182.142857,103.00097 182.142857,102.373637 C182.142857,101.74578 182.652491,101.236891 183.281513,101.236891 C183.910009,101.236891 184.419643,101.74578 184.419643,102.373637 C184.419643,103.00097 183.910009,103.510383 183.281513,103.510383",
    id: "Fill-37",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,111.467604 C182.652491,111.467604 182.142857,110.958715 182.142857,110.330858 C182.142857,109.704049 182.652491,109.194112 183.281513,109.194112 C183.910009,109.194112 184.419643,109.704049 184.419643,110.330858 C184.419643,110.958715 183.910009,111.467604 183.281513,111.467604",
    id: "Fill-38",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,117.151333 C182.652491,117.151333 182.142857,116.642444 182.142857,116.014587 C182.142857,115.38673 182.652491,114.877841 183.281513,114.877841 C183.910009,114.877841 184.419643,115.38673 184.419643,116.014587 C184.419643,116.642444 183.910009,117.151333 183.281513,117.151333",
    id: "Fill-39",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,125.108554 C182.652491,125.108554 182.142857,124.599665 182.142857,123.971808 C182.142857,123.343951 182.652491,122.835062 183.281513,122.835062 C183.910009,122.835062 184.419643,123.343951 184.419643,123.971808 C184.419643,124.599665 183.910009,125.108554 183.281513,125.108554",
    id: "Fill-40",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,134.202521 C182.652491,134.202521 182.142857,133.693632 182.142857,133.065775 C182.142857,132.438442 182.652491,131.929029 183.281513,131.929029 C183.910009,131.929029 184.419643,132.438442 184.419643,133.065775 C184.419643,133.693632 183.910009,134.202521 183.281513,134.202521",
    id: "Fill-41",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,141.022996 C182.652491,141.022996 182.142857,140.514107 182.142857,139.88625 C182.142857,139.258393 182.652491,138.749504 183.281513,138.749504 C183.910009,138.749504 184.419643,139.258393 184.419643,139.88625 C184.419643,140.514107 183.910009,141.022996 183.281513,141.022996",
    id: "Fill-42",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,147.843471 C182.652491,147.843471 182.142857,147.333534 182.142857,146.706725 C182.142857,146.078868 182.652491,145.569979 183.281513,145.569979 C183.910009,145.569979 184.419643,146.078868 184.419643,146.706725 C184.419643,147.333534 183.910009,147.843471 183.281513,147.843471",
    id: "Fill-43",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,154.663946 C182.652491,154.663946 182.142857,154.155057 182.142857,153.5272 C182.142857,152.899343 182.652491,152.390454 183.281513,152.390454 C183.910009,152.390454 184.419643,152.899343 184.419643,153.5272 C184.419643,154.155057 183.910009,154.663946 183.281513,154.663946",
    id: "Fill-44",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.281513,162.621167 C182.652491,162.621167 182.142857,162.111229 182.142857,161.484421 C182.142857,160.856564 182.652491,160.347675 183.281513,160.347675 C183.910009,160.347675 184.419643,160.856564 184.419643,161.484421 C184.419643,162.111229 183.910009,162.621167 183.281513,162.621167",
    id: "Fill-45",
    fill: "#DFDFF4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#DFDFF4",
    points: "350.625 31.8953952 389.330357 31.8953952 389.330357 29.6219035 350.625 29.6219035"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#DFDFF4",
    points: "350.625 38.7158702 389.330357 38.7158702 389.330357 36.4423785 350.625 36.4423785"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#DFDFF4",
    points: "350.625 45.5363453 389.330357 45.5363453 389.330357 43.2628536 350.625 43.2628536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#DFDFF4",
    points: "319.888393 52.3568203 388.191964 52.3568203 388.191964 50.0833286 319.888393 50.0833286"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#DFDFF4",
    points: "334.6875 64.8610245 373.392857 64.8610245 373.392857 62.5875328 334.6875 62.5875328"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#DFDFF4",
    points: "334.6875 71.6814995 373.392857 71.6814995 373.392857 69.4080079 334.6875 69.4080079"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#DFDFF4",
    points: "223.125 71.6814995 261.830357 71.6814995 261.830357 69.4080079 223.125 69.4080079"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#DFDFF4",
    points: "334.6875 77.3652287 373.392857 77.3652287 373.392857 75.0917371 334.6875 75.0917371"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#DFDFF4",
    points: "251.584821 31.8953952 346.071429 31.8953952 346.071429 29.6219035 251.584821 29.6219035"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#DFDFF4",
    points: "275.491071 38.7158702 346.071429 38.7158702 346.071429 36.4423785 275.491071 36.4423785"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#DFDFF4",
    points: "221.986607 38.7158702 270.9375 38.7158702 270.9375 36.4423785 221.986607 36.4423785"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#DFDFF4",
    points: "207.1875 45.5363453 347.209821 45.5363453 347.209821 43.2628536 207.1875 43.2628536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#DFDFF4",
    points: "216.294643 52.3568203 307.366071 52.3568203 307.366071 50.0833286 216.294643 50.0833286"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#DFDFF4",
    points: "206.049107 64.8610245 327.857143 64.8610245 327.857143 62.5875328 206.049107 62.5875328"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#DFDFF4",
    points: "266.383929 71.6814995 330.133929 71.6814995 330.133929 69.4080079 266.383929 69.4080079"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#DFDFF4",
    points: "231.09375 77.3652287 330.133929 77.3652287 330.133929 75.0917371 231.09375 75.0917371"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#DFDFF4",
    points: "313.058036 86.4591954 351.763393 86.4591954 351.763393 84.1857038 313.058036 84.1857038"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#DFDFF4",
    points: "207.1875 86.4591954 239.0625 86.4591954 239.0625 84.1857038 207.1875 84.1857038"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#DFDFF4",
    points: "245.892857 86.4591954 308.504464 86.4591954 308.504464 84.1857038 245.892857 84.1857038"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#DFDFF4",
    points: "196.941964 94.4164163 350.625 94.4164163 350.625 92.1429246 196.941964 92.1429246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#DFDFF4",
    points: "262.96875 101.236891 351.763393 101.236891 351.763393 98.9633997 262.96875 98.9633997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#DFDFF4",
    points: "195.803571 101.236891 257.276786 101.236891 257.276786 98.9633997 195.803571 98.9633997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#DFDFF4",
    points: "334.6875 108.057366 373.392857 108.057366 373.392857 105.783875 334.6875 105.783875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#DFDFF4",
    points: "275.491071 114.877841 371.116071 114.877841 371.116071 112.60435 275.491071 112.60435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#DFDFF4",
    points: "195.803571 113.741096 268.660714 113.741096 268.660714 111.467604 195.803571 111.467604"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#DFDFF4",
    points: "299.397321 121.698316 369.977679 121.698316 369.977679 119.424825 299.397321 119.424825"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#DFDFF4",
    points: "285.736607 127.382046 369.977679 127.382046 369.977679 125.108554 285.736607 125.108554"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#DFDFF4",
    points: "255 135.339266 348.348214 135.339266 348.348214 133.065775 255 133.065775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#DFDFF4",
    points: "229.955357 142.159742 348.348214 142.159742 348.348214 139.88625 229.955357 139.88625"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#DFDFF4",
    points: "310.78125 148.980217 349.486607 148.980217 349.486607 146.706725 310.78125 146.706725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#DFDFF4",
    points: "199.21875 155.800692 215.15625 155.800692 215.15625 153.5272 199.21875 153.5272"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#DFDFF4",
    points: "219.709821 155.800692 348.348214 155.800692 348.348214 153.5272 219.709821 153.5272"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    fill: "#DFDFF4",
    points: "305.089286 163.757912 343.794643 163.757912 343.794643 161.484421 305.089286 161.484421"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-79",
    fill: "#DFDFF4",
    points: "210.602679 163.757912 301.674107 163.757912 301.674107 161.484421 210.602679 161.484421"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#DFDFF4",
    points: "157.098214 31.8953952 195.803571 31.8953952 195.803571 29.6219035 157.098214 29.6219035"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-81",
    fill: "#DFDFF4",
    points: "157.098214 38.7158702 195.803571 38.7158702 195.803571 36.4423785 157.098214 36.4423785"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    fill: "#DFDFF4",
    points: "137.745536 52.3568203 194.665179 52.3568203 194.665179 50.0833286 137.745536 50.0833286"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    fill: "#DFDFF4",
    points: "137.745536 64.8610245 182.142857 64.8610245 182.142857 62.5875328 137.745536 62.5875328"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#DFDFF4",
    points: "137.745536 31.8953952 151.40625 31.8953952 151.40625 29.6219035 137.745536 29.6219035"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-85",
    fill: "#DFDFF4",
    points: "137.745536 38.7158702 151.40625 38.7158702 151.40625 36.4423785 137.745536 36.4423785"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    fill: "#DFDFF4",
    points: "137.745536 86.4591954 149.129464 86.4591954 149.129464 84.1857038 137.745536 84.1857038"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    fill: "#DFDFF4",
    points: "171.897321 77.3652287 183.28125 77.3652287 183.28125 75.0917371 171.897321 75.0917371"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#DFDFF4",
    points: "137.745536 94.4164163 149.129464 94.4164163 149.129464 92.1429246 137.745536 92.1429246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#DFDFF4",
    points: "137.745536 114.877841 163.928571 114.877841 163.928571 112.60435 137.745536 112.60435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-90",
    fill: "#DFDFF4",
    points: "137.745536 127.382046 163.928571 127.382046 163.928571 125.108554 137.745536 125.108554"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    fill: "#DFDFF4",
    points: "136.607143 135.339266 146.852679 135.339266 146.852679 133.065775 136.607143 133.065775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-92",
    fill: "#DFDFF4",
    points: "136.607143 155.800692 146.852679 155.800692 146.852679 153.5272 136.607143 153.5272"
  })), /*#__PURE__*/React.createElement("g", {
    id: "error",
    transform: "translate(201.428571, 168.026756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.994326,86.5442415 L66.8466255,3.15399212 C64.1161509,-1.05133071 58.0267898,-1.05133071 55.2957635,3.15399212 L1.14861482,86.5442415 C-1.87427271,91.1993139 1.42226917,97.3913043 6.92404584,97.3913043 L115.218895,97.3913043 C120.72012,97.3913043 124.017213,91.1993139 120.994326,86.5442415",
    id: "Fill-93",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4642857,80.0829063 C54.4642857,77.6437354 55.1178043,75.7489176 56.4254296,74.3945462 C57.7324667,73.0421281 59.6324352,72.3642912 62.1259232,72.3642912 C64.5958821,72.3642912 66.4652629,73.0421281 67.7364182,74.3945462 C69.0075736,75.7489176 69.6428571,77.6437354 69.6428571,80.0829063 C69.6428571,82.4940782 68.9834563,84.3778266 67.6634783,85.7295935 C66.3440884,87.0826627 64.4988249,87.7591973 62.1259232,87.7591973 C59.7294924,87.7591973 57.8536412,87.0826627 56.4977814,85.7295935 C55.1419215,84.3778266 54.4642857,82.4940782 54.4642857,80.0829063 L54.4642857,80.0829063 Z M67.7457199,66.0252122 L55.4685659,66.0252122 L53.5714286,28.8963211 L69.6428571,28.8963211 L67.7457199,66.0252122 Z",
    id: "Fill-94",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(70.714286, 75.451505) scale(-1, 1) translate(-70.714286, -75.451505) translate(6.428571, 5.351171)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.076531, 0.853040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2620027,95.3406693 C98.9428647,94.6629563 126.912675,70.2923957 126.912675,70.2923957 L122.146641,68.2592566 C119.423193,66.930939 120.13129,65.1417766 120.784917,63.5423739 C121.438545,61.4821262 126.259048,45.298339 126.259048,45.298339 C126.259048,45.298339 113.268201,48.0091912 110.544753,48.6869042 C108.502167,49.3375087 107.821305,48.0091912 107.140443,46.6537651 C106.459581,45.298339 103.055271,37.8706042 103.055271,37.8706042 C103.055271,37.8706042 88.7299348,54.1086085 88.0490728,54.759213 C85.3256249,56.7923521 82.5749424,54.759213 83.2558044,52.0483608 C83.2558044,49.3375087 90.7725208,16.9157173 90.7725208,16.9157173 C90.7725208,16.9157173 82.5749424,21.6326 79.8514944,22.988026 C77.8089085,24.3434521 76.41995,24.3434521 75.058226,21.6326 C73.6692676,19.5994609 63.4291032,0 63.4291032,0 C63.4291032,0 53.2161733,19.5994609 51.8544493,21.6326 C50.4927253,24.3434521 49.1310014,24.3434521 47.0611809,22.988026 C44.3377329,21.6326 36.1401545,16.9157173 36.1401545,16.9157173 C36.1401545,16.9157173 43.6568709,49.3375087 43.6568709,52.0483608 C44.3377329,54.759213 41.614285,56.7923521 38.8636025,54.759213 C38.1827405,54.0814999 23.8574042,37.8706042 23.8574042,37.8706042 C23.8574042,37.8706042 20.4530942,45.2712305 19.7722323,46.6266566 C19.0913703,47.9820827 18.4105083,49.3104002 16.3679223,48.6597957 C13.6172398,47.9820827 0.653627512,45.2712305 0.653627512,45.2712305 C0.653627512,45.2712305 5.44689594,61.4550177 6.12775793,63.5152653 C6.78138544,65.1417766 7.48948191,66.9038305 4.76603395,68.232148 L0,70.2923957 C0,70.2923957 27.9425762,94.6629563 28.6506726,95.3406693 C30.0396311,96.6960954 31.3741206,97.3738084 30.0396311,101.440087 C28.6506726,105.506365 27.2889486,110.955178 27.2889486,110.955178 C27.2889486,110.955178 53.2161733,105.506365 55.9668558,104.828652 C58.3362555,104.584675 60.9507655,105.506365 60.9507655,108.217217 C60.9507655,110.928069 59.3711657,138.795629 59.3711657,138.795629 L67.5415096,138.795629 C67.5415096,138.795629 65.9619098,110.955178 65.9619098,108.217217 C65.9619098,105.479256 68.5491854,104.584675 70.9730541,104.828652 C73.696502,105.506365 99.6237267,110.955178 99.6237267,110.955178 C99.6237267,110.955178 98.2620027,105.506365 96.9002787,101.440087 C95.5385547,97.3738084 96.9002787,96.6960954 98.2620027,95.3406693 L98.2620027,95.3406693 Z",
    id: "Path",
    fill: "#FE3146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4291032,0 C63.4291032,0 53.2161733,19.5994609 51.8544493,21.6326 C50.4927253,24.3434521 49.1310014,24.3434521 47.0611809,22.988026 C44.3377329,21.6326 36.1401545,16.9157173 36.1401545,16.9157173 C36.1401545,16.9157173 43.6568709,49.3375087 43.6568709,52.0483608 C44.3377329,54.759213 41.614285,56.7923521 38.8636025,54.759213 C38.1827405,54.0814999 23.8574042,37.8706042 23.8574042,37.8706042 C23.8574042,37.8706042 20.4530942,45.2712305 19.7722323,46.6266566 C19.0913703,47.9820827 18.4105083,49.3104002 16.3679223,48.6597957 C13.6172398,47.9820827 0.653627512,45.2712305 0.653627512,45.2712305 C0.653627512,45.2712305 5.44689594,61.4550177 6.12775793,63.5152653 C6.78138544,65.1417766 7.48948191,66.9038305 4.76603395,68.232148 L0,70.2923957 C0,70.2923957 27.9425762,94.6629563 28.6506726,95.3406693 C30.0396311,96.6960954 31.3741206,97.3738084 30.0396311,101.440087 C28.6506726,105.506365 27.2889486,110.955178 27.2889486,110.955178 C27.2889486,110.955178 53.2161733,105.506365 55.9668558,104.828652 C58.3362555,104.584675 60.9507655,105.506365 60.9507655,108.217217 C60.9507655,110.928069 59.3711657,138.795629 59.3711657,138.795629 L63.4563377,138.795629 C63.4563377,138.795629 63.4291032,0 63.4291032,0 Z",
    id: "Path",
    fill: "#D6293B"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorProblem);
export default __webpack_public_path__ + "static/media/errorProblem.63f3ffd4b0a8251b25349ab27236a70c.svg";
export { ForwardRef as ReactComponent };